// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { inverseBackground, inverseIcon } from '../../tokens/themeColors/inverse';
import { text } from '../../tokens/themeColors/text';
export var badgeColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var tx = text(mode);
    // Default Bold and the bold status variants intentionally use the opposite mode's
    // background/icon values (Figma: Inverse/Background Colors/Level 0, Inverse/Icon Colors/Heaviest).
    var inverseBg = inverseBackground(mode);
    var inverseIc = inverseIcon(mode);
    return {
        default: {
            background: bg.level200,
            border: bd.active,
            icon: ic.active,
            text: tx.primary
        },
        defaultBold: {
            background: inverseBg.level0,
            border: inverseBg.level0,
            icon: inverseIc.heaviest,
            text: tx.action
        },
        error: {
            background: bg.status.errorBold4,
            border: bg.status.errorBold4,
            icon: inverseIc.heaviest,
            text: tx.action
        },
        info: {
            background: bg.accent,
            border: bg.accent,
            icon: inverseIc.heaviest,
            text: tx.action
        },
        special: {
            background: bg.status.specialBold,
            border: bg.status.specialBold,
            icon: inverseIc.heaviest,
            text: tx.action
        },
        success: {
            background: bg.status.successBold2,
            border: bg.status.successBold2,
            icon: ic.black,
            text: tx.black
        },
        warning: {
            background: bg.status.warningBold1,
            border: bg.status.warningBold1,
            icon: ic.black,
            text: tx.black
        },
        // Separates a bordered dot from whatever it overlaps (Figma: Background Colors/Level 0).
        ring: bg.level0
    };
};

//# sourceMappingURL=badgeColors.js.map